import { useAvailabilityPageFetch } from "@tenant/hotels";
import { useAvailabilityPageContainer } from "@tenant/hotels";
import type { AvailabilityPageHookProps } from "../types";

export const useAvailabilityPage = (props: AvailabilityPageHookProps) => {
  useAvailabilityPageFetch(props);
  return useAvailabilityPageContainer();
};
